import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { pittsburghConfig } from "./data";

export default function PittsburghPage() {
  return <CityPageTemplate config={pittsburghConfig} />;
}